import * as React from 'react'
import Carousel from 'src/share/components/Carousel/Carousel';
import PDBanner from './PDBanner';
import useCarousel from 'src/share/components/Carousel/hooks/useCarousel';

function PDChildren({ children, onTransition }): React.ReactElement {
  const [{ currentIndex, isPlaying }, actions ] = useCarousel(children.length);
  // const [ isMouseHovering, setIsMouseHovering ] = React.useState(false);
  React.useEffect(() => {
    if(children.length) {
      onTransition(children[currentIndex]);
    }
  }, [currentIndex]);
  /* function handleIsHovering() {
    setIsMouseHovering(prevIsMouseHovering => !prevIsMouseHovering);
  } */
  return (
    <div className="partners-dashboard__children box" /* onMouseEnter={handleIsHovering} onMouseLeave={handleIsHovering} */>
      <Carousel
        currentIndex={currentIndex}
        isPlaying={isPlaying}
        withControls={true}
        withProgressBar={true}
        onPause={actions.handlePause}
        onPlay={actions.handlePlay}
        onNext={actions.handleNext}
        onPrev={actions.handlePrev}
        onGoTo={actions.handleGoTo}
      >
        {children.map((child, index) => (
          <PDBanner 
            key={index}
            id={`image-${index}`}
            child={child}
            isCurrent={index === currentIndex}
          />
        ))}
      </Carousel>
    </div>
  )
}

export default React.memo(PDChildren);
